@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.verifictionLinkWrapper {
  padding: variables.$std-padding-md 0;
}
